if (!customElements.get('ls-sticky-atc')) {
  customElements.define(
    'ls-sticky-atc',
    class LsStickyAtc extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.ls-sticky-atc__button');
        this.mainAtcButton = document.querySelector('product-form .product-form__submit[name="add"]');

        if (!this.button || !this.mainAtcButton) return;

        this.button.addEventListener('click', () => this.mainAtcButton.click());

        this.syncDisabledState = () => {
          this.button.disabled = this.mainAtcButton.disabled;
        };
        this.syncDisabledState();
        this.buttonObserver = new MutationObserver(this.syncDisabledState);
        this.buttonObserver.observe(this.mainAtcButton, { attributeFilter: ['disabled'] });

        this.visibilityObserver = new IntersectionObserver(
          (entries) => entries.forEach((entry) => this.classList.toggle('is-visible', !entry.isIntersecting)),
          { threshold: 0 }
        );
        this.visibilityObserver.observe(this.mainAtcButton);
      }

      disconnectedCallback() {
        this.buttonObserver?.disconnect();
        this.visibilityObserver?.disconnect();
      }
    }
  );
}
